import { useLocation } from "react-router";

const useUrlQuery = () => {
  const { search } = useLocation();
  const paramIterator = new URLSearchParams(search.substring(1));
  return Array.from(paramIterator.entries());
};

export default useUrlQuery;
